var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowForwardOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H20C20.5439 13 21 12.5439 21 12C21 11.4561 20.5439 11 20 11H4C3.45614 11 3 11.4561 3 12C3 12.5439 3.45614 13 4 13ZM20.7018 11.2982L13.7018 4.29824C13.5263 4.10526 13.2807 4 13 4C12.4561 4 12 4.45614 12 5C12 5.2807 12.1053 5.52632 12.2982 5.70175L19.2982 12.7018C19.4737 12.8947 19.7193 13 20 13C20.5439 13 21 12.5439 21 12C21 11.7193 20.8947 11.4737 20.7018 11.2982ZM13.7018 19.7018L20.7018 12.7018C20.8947 12.5263 21 12.2807 21 12C21 11.4561 20.5439 11 20 11C19.7193 11 19.4737 11.1053 19.2982 11.2982L12.2982 18.2982C12.1053 18.4737 12 18.7193 12 19C12 19.5439 12.4561 20 13 20C13.2807 20 13.5263 19.8947 13.7018 19.7018Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardOutlined);
export default __webpack_public_path__ + "static/media/arrow_forward_outlined.2c29d6b7.svg";
export { ForwardRef as ReactComponent };